import createIcon from '../../createIcon';

/**
 * @component @name ThumbUp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMSAyMkg1VjEwSDFWMjJaTTIzIDExQzIzIDkuOSAyMi4xIDkgMjEgOUgxNC42OUwxNS42NCA0LjQzTDE1LjY3IDQuMTFDMTUuNjcgMy43IDE1LjUgMy4zMiAxNS4yMyAzLjA1TDE0LjE3IDJMNy41OSA4LjU5QzcuMjIgOC45NSA3IDkuNDUgNyAxMFYyMEM3IDIxLjEgNy45IDIyIDkgMjJIMThDMTguODMgMjIgMTkuNTQgMjEuNSAxOS44NCAyMC43OEwyMi44NiAxMy43M0MyMi45NSAxMy41IDIzIDEzLjI2IDIzIDEzVjExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ThumbUp = createIcon('ThumbUp', [
  [
    'path',
    {
      d: 'M1 22H5V10H1V22ZM23 11C23 9.9 22.1 9 21 9H14.69L15.64 4.43L15.67 4.11C15.67 3.7 15.5 3.32 15.23 3.05L14.17 2L7.59 8.59C7.22 8.95 7 9.45 7 10V20C7 21.1 7.9 22 9 22H18C18.83 22 19.54 21.5 19.84 20.78L22.86 13.73C22.95 13.5 23 13.26 23 13V11Z',
      key: '1wn0cp',
    },
  ],
]);

export default ThumbUp;
